import dig from '@/utils/Dig.js'

export const getSuppressedRecipients = (inspection) =>
  dig(inspection, 'attributes.publish_recipients_with_sms_suppression') || []

export const buildSuppressionNoticeText = (recipients) => {
  if (!recipients || recipients.length === 0) return ''

  const namesWithLabels = recipients
    .map((r) => `${r.name} (${r.label})`)
    .join(', ')
  const verb = recipients.length === 1 ? 'has' : 'have'

  return `${namesWithLabels} ${verb} opted out of text messages. You can't send them SMS notifications until they opt back in.`
}
